module.exports = __webpack_public_path__ + "img/experiment-category-icon.3ca1b7df.svg";